import { api } from "./api";
import type { ApiResponse } from "@/shared/dto";

const BASE_URL = "/tournament-knockout-slots/private";

export interface SyncManualResult {
  success: boolean;
  syncedSlots: number;
  message: string;
}

export const tournamentKnockoutSlotService = {
  syncManual: (seasonId: string, stageOrder: number) =>
    api.post<ApiResponse<SyncManualResult>>(
      `${BASE_URL}/sync-manual`,
      { seasonId, stageOrder }
    ),
};
